import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  /**
   * 은행 점검 정보 조회
   * @param {Object} query - 쿼리 파라미터
   * @param {string} query.bank - 은행 코드 (선택)
   * @param {boolean} query.ongoing - 현재 진행 중인 점검만 조회 (선택)
   * @returns {Promise<{
   *   count: number,
   *   next: string|null,
   *   previous: string|null,
   *   results: Array<{
   *     uuid: string,
   *     bank: string,
   *     start_time: string,
   *     end_time: string,
   *     description: string,
   *     is_active: boolean,
   *     is_ongoing: boolean
   *   }>
   * }>}
   */
  getBankMaintenances(query = {}) {
    const queryString = qs.stringify(query, { skipNull: true, skipEmptyString: true })
    return defaultClient.get(`/bank-maintenances${queryString ? `?${queryString}` : ''}`)
  },
}
